import PropTypes from 'prop-types';
import React from 'react';
import DealSideRow from './DealSideRow';

function DealDonorCard({ donor, teamId, title = 'Donor' }) {
  if (!donor) return null;

  const { giving } = donor;
  const lastGift = giving && giving.last_gift_date
    ? [giving.last_gift_date, giving.last_gift_amount].filter(Boolean).join(' · ')
    : null;

  return (
    <div className="deal-side-card">
      <div className="deal-side-card-title">{title}</div>
      <div className="deal-side-donor">
        {donor.id ? (
          <a href={`/teams/${teamId}/crm/fans/${donor.id}`} className="deal-side-donor-name">
            {donor.name || '(No name)'}
          </a>
        ) : (
          <span className="deal-side-donor-name">{donor.name || '(No name)'}</span>
        )}
        {donor.organization_name && (
          <div className="deal-side-donor-org">{donor.organization_name}</div>
        )}
      </div>

      <DealSideRow label="Email" value={donor.email} />
      <DealSideRow label="Phone" value={donor.phone} />

      {giving && (
        <>
          <DealSideRow label="Lifetime giving" value={giving.lifetime} />
          <DealSideRow label="Last gift" value={lastGift} />
          <DealSideRow label="First gift" value={giving.first_gift_date} />
        </>
      )}
    </div>
  );
}

DealDonorCard.propTypes = {
  donor: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    organization_name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    giving: PropTypes.shape({
      lifetime: PropTypes.string,
      last_gift_amount: PropTypes.string,
      last_gift_date: PropTypes.string,
      first_gift_date: PropTypes.string,
    }),
  }),
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string,
};

export default DealDonorCard;
